import React from 'react';
import PropTypes from 'prop-types';
import CabecalhoSecao from '../../components/CabecalhoSecao';

// Bloco Cabeçalho de seção (22/10/2026): só o cabeçalho, como marcador entre
// seções da página (selo, título e o link opcional à direita), no mesmo
// desenho do cabeçalho da grade de notícias. Sem título não há o que marcar,
// e nada é desenhado na página.
const View = ({ data = {} }) => {
  if (!data.title) return null;
  return (
    <section className="ag-cabecalho-secao">
      <CabecalhoSecao
        prefixo="ag-news-grid"
        selo={data.eyebrow}
        titulo={data.title}
        linkTexto={data.linkText}
        linkHref={data.linkHref}
      />
    </section>
  );
};

View.propTypes = {
  data: PropTypes.shape({
    eyebrow: PropTypes.string,
    title: PropTypes.string,
    linkText: PropTypes.string,
    linkHref: PropTypes.string,
  }),
};

export default View;
